import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/contact/page.tsx");
